import React, { useEffect } from 'react';

const Backdrop = ({ close, ...props }) => {
    useEffect(() => {
        document.querySelector('html').className = 'hide_overflow';

        return () => {
            document.querySelector('html').className = '';
        };
    }, []);
    return <div {...props} onClick={close} className="backdrop"></div>;
};

export default Backdrop;
